export default "__VITE_ASSET__MpuWVh50__"